import { Box, Button, Grid, Paper, TextField } from "@mui/material";
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import api from "../api";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const EmployeeDetailsView = (props) => {
    let { employeeID } = useParams();
    let navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [employee, setEmployee] = useState({
        name: "",
        number: "",
        company: "",
        email: "",
        hours_per_week: ""
    })

    const [error, setError] = useState("")

    useEffect(() => {
        getEmployee()
    }, [])

    const getEmployee = async () => {
        if (employeeID) {
            let res = await api.get('/employees/' + employeeID)
            setEmployee(res.data)
        }
    }

    const saveEmployee = async (e) => {
        e.preventDefault();
        let res;
        if (employeeID) {
            res = await api.patch(`/employees/${employeeID}/`, employee)
        }
        else {
            res = await api.post('/employees/', employee)
        }

        if (res.status === 200 || res.status === 201) {
            navigate("/admin")
        }
        else if (res.response.status === 400) {
            console.log("****")
            if (res.response.data.non_field_errors[0] === "The fields number, company must make a unique set.") {
                setError("Le numéro est déjà utilisé. Veuillez entrer un numéro différent.")
            }
        }
    }

    const deleteEmployee = async (e) => {

        let res = await api.delete(`/employees/${employeeID}/`)
        navigate("/admin")

    }

    const handleChange = (e) => {
        setEmployee({ ...employee, [e.target.name]: e.target.value })
    }


    return (
        <div style={{ padding: "10px 64px" }}>
            <div className="page-title">
                <a onClick={() => navigate(-1)} className="back-arrow">
                    <FontAwesomeIcon icon={faArrowLeft} />
                </a>
                <h1 >{employeeID ? "Modification d'un employé" : "Ajout d'un employé"}</h1>
            </div>
            <Paper elevation={3} style={{ padding: "16px" }}>

                <Box
                    component="form"
                    alignContent="center"
                    width={"100%"}
                    onChange={handleChange}
                    onSubmit={saveEmployee}
                    flex={1}
                    display="flex"
                    flexDirection={"column"}
                >
                    <TextField
                        label="Nom"
                        sx={{ margin: "4px" }}
                        name="name"
                        value={employee.name}
                    />
                    <TextField
                        label="Numéro d'employé"
                        sx={{ margin: "4px" }}
                        name="number"
                        value={employee.number}
                    />
                    <TextField
                        label="Adresse email"
                        sx={{ margin: "4px" }}
                        name="email"
                        type={"email"}
                        value={employee.email}
                    />
                    <TextField
                        label="Nombre d'heures par semaine"
                        sx={{ margin: "4px" }}
                        name="hours_per_week"
                        type={"number"}
                        value={employee.hours_per_week}
                    />

                    <div>
                        <Button
                            type={"submit"}
                            sx={{ margin: "4px", float: "right" }}
                            variant="contained">
                            Sauvegarder
                        </Button>

                        {employeeID && <Button
                            variant="contained"
                            color="error"
                            onClick={handleOpen}
                            sx={{ margin: "4px", float: "right" }}>
                            Supprimer
                        </Button>}
                    </div>

                </Box>
            </Paper>

            <p style={{ color: "red", textAlign: "center" }}>{error}</p>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="delete-modal"
                aria-describedby="delete-modal"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Supprimer l'employé?
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        Voulez-vous vraiment supprimer l'employé {employee.name} ?
                    </Typography>

                    <Button
                        variant="contained"
                        color="error"
                        onClick={deleteEmployee}
                        sx={{ margin: "4px", float: "right" }}>
                        Supprimer
                    </Button>
                    <Button
                        onClick={handleClose}
                        color="info"
                        sx={{ margin: "4px", float: "right" }}
                        variant="contained"
                    >
                        Annuler
                    </Button>
                </Box>
            </Modal>
        </div>
    )

}
export default EmployeeDetailsView